import PostIt from 'postit-js'
import { mutationNames } from '@/store/storeKeysettings'
import { HashCodeFromInt, IsValid } from '@/modules/helper/index'

const createEmulatorPlugin = () => {
  const emulator = PostIt.add(mutationNames.EMULATOR_NAME)
  // setTimeout(() => {
  emulator.emit(mutationNames.EMULATOR_NAME, 'ready', window.parent, { message: 'Message from `iframe.html`' }, '*')
  emulator.emit(mutationNames.EMULATOR_NAME, 'load', window.parent, { message: 'loaded' }, '*')
  // }, 2000)
  return store => {
    // emulator.on(mutationNames.EMULATOR_NAME, '*', (event) => {
    //   console.log(mutationNames.EMULATOR_NAME, event)
    // })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_DESIGN_SETTINGS, (event) => {
      let finalData = Object.assign({}, store.getters.AppConfig.DesignSettings, event.dataParsed.DesignSettings)
      store.commit(mutationNames.SET_DESIGN_SETTINGS, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_START_PAGE, (event) => {
      let finalData = Object.assign({}, store.getters.AppConfig.MainMenu, event.dataParsed.MainMenu)
      // console.log('finalData', finalData)
      // More icon color set
      finalData = colorMoreIconUpdationCode(store, finalData)
      store.commit(mutationNames.SET_START_PAGE, finalData)
      let ModuleData = colorUpdationCode(store, {})
      store.commit(mutationNames.SET_SUBSCRIPTIONS_MODULES, ModuleData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_SUBSCRIPTIONS_MODULES, (event) => {
      let finalData = colorUpdationCode(store, event.dataParsed)
      store.commit(mutationNames.SET_SUBSCRIPTIONS_MODULES, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_DEVICE, (event) => {
      store.commit('setActiveDevice', event.dataParsed.selectedDevice)
      window.localStorage.setItem('initialStore', JSON.stringify(store.state)) // used in aap.vue to set old state in new device.
      window.localStorage.setItem('selectedDevice', event.dataParsed.selectedDevice)
      window.location.reload()
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_ACTIVE_MODULE, (event) => {
      let finalData = event.dataParsed.ActiveModule
      finalData = `/${finalData}`
      store.commit(mutationNames.SET_ACTIVE_MODULE, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_STREAM, (event) => {
      let finalData = Object.assign({}, store.getters.Stream, event.dataParsed.stream)
      store.commit(mutationNames.UPDATE_STREAM, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_YOUTUBE, (event) => {
      let finalData = Object.assign({}, store.getters.YoutubeData, event.dataParsed.youtube)
      store.commit(mutationNames.UPDATE_YOUTUBE, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_TWITTERDATA, (event) => {
      let finalData = Object.assign({}, store.getters.Twitter, event.dataParsed.twitter)
      store.commit(mutationNames.UPDATE_TWITTERDATA, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_WEBSITE, (event) => {
      let finalData = Object.assign({}, store.getters.Website, event.dataParsed.website)
      store.commit(mutationNames.UPDATE_WEBSITE, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_INSTAGRAM, (event) => {
      let finalData = Object.assign({}, store.getters.Instagram, event.dataParsed.instagram)
      store.commit(mutationNames.UPDATE_INSTAGRAM, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_FACEBOOK, (event) => {
      let finalData = Object.assign({}, store.getters.Facebook, event.dataParsed.facebook)
      store.commit(mutationNames.UPDATE_FACEBOOK, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_RSSFEEDDATA, (event) => {
      let finalData = Object.assign({}, store.getters.RssFeed, event.dataParsed.rssfeed)
      store.commit(mutationNames.UPDATE_RSSFEEDDATA, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_TEAMPARENT, (event) => {
      let finalData = Object.assign({}, store.getters.TeamMember.Parent, event.dataParsed.parent)
      store.commit(mutationNames.SET_TEAMMEMBERS, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_TEAMPRESON, (event) => {
      let finalData = event.dataParsed.persons
      store.commit(mutationNames.SET_TEAMMEMBERSPERSONS, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_CONTENT_PAGE_PARENT, (event) => {
      let finalData = Object.assign({}, store.getters.ContentPageParent, event.dataParsed.ContentPageParent)
      store.commit(mutationNames.SET_CONTENT_PAGE_PARENT, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_CONTENT_PAGES, (event) => {
      let data = [...new Set(event.dataParsed.ContentPages.map(post => post.Category))]
      let contentPages = []
      for (let category of data) {
        let Pages = {
          Category: category,
          Posts: []
        }
        Pages.Posts.push(event.dataParsed.ContentPages.filter(post => post.Category === category))
        contentPages.push(Pages)
      }
      let tempArray = []
      contentPages.forEach(function(Page) {
        let tempPages = {
          Category: Page.Category,
          Posts: []
        }
        Page.Posts.forEach(function(Post) {
          Post.forEach(function(item) {
            let itemfound = false
            let ContentPagesClone = store.getters.ContentPages
            ContentPagesClone.forEach(function(spages) {
              spages.Posts.forEach(function(spost) {
                if (spost.Id === item.Id) {
                  let obj = Object.assign({}, spost, item)
                  if (!obj.PostComments) {
                    obj.PostComments = []
                  }
                  tempPages.Posts.push(obj)
                  itemfound = true
                }
              })
            })
            if (!itemfound) {
              if (!item.PostComments) {
                item.PostComments = []
              }
              tempPages.Posts.push(item)
            }
          })
        })
        tempArray.push(tempPages)
      })
      store.commit(mutationNames.UPDATE_CONTENTPAGES, tempArray)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CREATE_NEW_CONTENT_PAGE, (event) => {
      let finalData = event.dataParsed.NewContentPage
      finalData.Id = '00000000-0000-0000-0000-000000000000'
      finalData.Content = null
      finalData.Active = true
      finalData.RowDeleted = false
      finalData.PostComments = []
      finalData.PostLikes = 0
      finalData.EventEndDate = null
      finalData.EventEndTime = null
      finalData.EventLocation = null
      finalData.EventStartDate = null
      finalData.EventStartTime = null
      finalData.MapAddressLine1 = null
      finalData.MapAddressLine2 = null
      finalData.PostAuthor = null
      finalData.PostDate = null
      finalData.PostImage = null
      let contentPages = store.getters.ContentPages.map(page => page)
      let page = contentPages.find(page => page.Category === finalData.Category)
      if (page && page.Posts) {
        page.Posts.push(finalData)
      } else {
        let tempPages = {
          Category: finalData.Category,
          Posts: []
        }
        tempPages.Posts.push(finalData)
        contentPages.push(tempPages)
      }
      store.commit(mutationNames.UPDATE_CONTENTPAGES, contentPages)
      store.commit(mutationNames.CREATE_NEW_CONTENT_PAGE, finalData)
      if (contentPages.length === 1 && contentPages[0].Posts.length === 1) {
      } else {
        let detailViewPath = `/${finalData.detailViewName}/${store.getters.ContentPage.Parent.SubscriptionModule_Id}/00000000-0000-0000-0000-000000000000`
        store.commit(mutationNames.SET_ACTIVE_MODULE, detailViewPath)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_NEW_CONTENT_PAGE, (event) => {
      let finalData = event.dataParsed.NewContentPagePost
      let newContentPage = store.getters.NewContentPage
      let contentPages = store.getters.ContentPages.map(page => page)
      let page = contentPages.find(page => page.Category === newContentPage.Category)
      if (page && page.Posts) {
        let post = page.Posts.find(post => post.Id === '00000000-0000-0000-0000-000000000000')
        Object.assign(post, finalData)
      }
      store.commit(mutationNames.UPDATE_CONTENTPAGES, contentPages)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CLEAR_CONTENT_EDITING_DATA, (event) => {
      let newContentPage = store.getters.NewContentPage
      let contentPages = store.getters.ContentPages.map(page => page)
      if (newContentPage) {
        let page = contentPages.find(page => page.Category === newContentPage.Category)
        // console.log('page', page)
        if (page && page.Posts) {
          if (contentPages.length === 1 && contentPages[0].Posts.length > 1) {
            store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
          }
          page.Posts = page.Posts.filter(post => post.Id !== '00000000-0000-0000-0000-000000000000')
        }
        store.commit(mutationNames.UPDATE_CONTENTPAGES, contentPages)
        store.commit(mutationNames.SET_SELECTED_CONTENT_TAB, newContentPage.Category)
        store.commit(mutationNames.CREATE_NEW_CONTENT_PAGE, null)
        // store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
      }
      if (contentPages.length === 1 && (contentPages[0].Posts.length === 0 || contentPages[0].Posts.length === 1)) {
      } else {
        store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CANCEL_CONTENT_PAGE_EDITING, (event) => {
      let contentPost = event.dataParsed.contentData
      contentPost.PostComments = []
      // console.log('contentPost', contentPost)
      let contentPages = store.getters.ContentPages.map(page => page)
      let page = contentPages.find(page => page.Category === contentPost.Category)
      if (page && page.Posts) {
        const index = page.Posts.findIndex(post => post.Id === contentPost.Id)
        page.Posts.splice(index, 1, contentPost)
      }
      store.commit(mutationNames.UPDATE_CONTENTPAGES, contentPages)
      store.commit(mutationNames.SET_SELECTED_CONTENT_TAB, contentPost.Category)
      // store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
    })
    emulator.on(mutationNames.EMULATOR_NAME, 'dummyMutation', (event) => {
      let finalData = event.dataParsed.appPath
      if (finalData !== '') {
        let appPath = window.location.href
        emulator.emit(mutationNames.EMULATOR_NAME, 'setDummyMutation', window.parent, { appPath: appPath }, '*')
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, 'UPDATE_UI', (event) => {
      let finalData = event.dataParsed.UI
      if (finalData) {
        store.commit(mutationNames.SET_SELECTED_CONTENT_TAB, finalData.activeCategoryTab)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, 'UPDATE_GALLERIE_UI', (event) => {
      let finalData = event.dataParsed.UI
      // console.log(finalData)
      if (finalData) {
        store.commit(mutationNames.SET_SELECTED_ALBUM_TAB, finalData.activeCategoryTab)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_IMAGE_GALLERIE_PARENT, (event) => {
      let finalData = Object.assign({}, store.getters.ImageGallerieParent, event.dataParsed.ImageGallerieParent)
      // console.log(finalData)
      store.commit(mutationNames.SET_IMAGE_GALLERIE_PARENT, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_IMAGE_GALLERIE_ALBUMS, (event) => {
      let data = [...new Set(event.dataParsed.GallerieAlbums.map(album => album.Category))]
      // console.log('event.dataParsed.GallerieAlbums', event.dataParsed.GallerieAlbums)
      let gallerieAlbums = []
      for (let category of data) {
        let Galleries = {
          Category: category,
          Albums: []
        }
        Galleries.Albums.push(event.dataParsed.GallerieAlbums.filter(album => album.Category === category))
        gallerieAlbums.push(Galleries)
      }
      let tempArray = []
      gallerieAlbums.forEach(function(Galleries) {
        let tempGalleries = {
          Category: Galleries.Category,
          Albums: []
        }
        Galleries.Albums.forEach(function(Gallerie) {
          Gallerie.forEach(function(album) {
            let itemfound = false
            let GalleriesClone = store.getters.Galleries
            GalleriesClone.forEach(function(sgallerie) {
              sgallerie.Albums.forEach(function(salbum) {
                if (salbum.Id === album.Id) {
                  let obj = Object.assign({}, salbum, album)
                  tempGalleries.Albums.push(obj)
                  itemfound = true
                }
              })
            })
            if (!itemfound) {
              tempGalleries.Albums.push(album)
            }
          })
        })
        tempArray.push(tempGalleries)
      })
      // console.log('tempArray', tempArray)
      store.commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS, tempArray)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM, (event) => {
      let finalData = event.dataParsed.NewGallerieAlbum
      finalData.Id = '00000000-0000-0000-0000-000000000000'
      let galleries = store.getters.Galleries.map(gallerie => gallerie)
      let gallerie = galleries.find(gallerie => gallerie.Category === finalData.Category)
      if (gallerie && gallerie.Albums) {
        gallerie.Albums.push(finalData)
      } else {
        let tempGallerie = {
          Category: finalData.Category,
          Albums: []
        }
        tempGallerie.Albums.push(finalData)
        galleries.push(tempGallerie)
      }
      store.commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS, galleries)
      store.commit(mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM, finalData)
      if (galleries.length === 1 && galleries[0].Albums.length === 1) {
      } else {
        let detailViewPath = `/${finalData.detailViewName}/${store.getters.ImageGalleries.Parent.SubscriptionModule_Id}/00000000-0000-0000-0000-000000000000`
        store.commit(mutationNames.SET_ACTIVE_MODULE, detailViewPath)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_NEW_IMAGE_GALLERIE_ALBUM, (event) => {
      let finalData = event.dataParsed.NewGallerieAlbum
      let newGallerieAlbum = store.getters.NewGallerieAlbum
      let galleries = store.getters.Galleries.map(gallerie => gallerie)
      let gallerie = galleries.find(gallerie => gallerie.Category === newGallerieAlbum.Category)
      if (gallerie && gallerie.Albums) {
        let album = gallerie.Albums.find(album => album.Id === '00000000-0000-0000-0000-000000000000')
        Object.assign(album, finalData)
      }
      store.commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS, galleries)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA, (event) => {
      let newGallerieAlbum = store.getters.NewGallerieAlbum
      let galleries = store.getters.Galleries.map(gallerie => gallerie)
      if (newGallerieAlbum) {
        let gallerie = galleries.find(gallerie => gallerie.Category === newGallerieAlbum.Category)
        // console.log('page', page)
        if (gallerie && gallerie.Albums) {
          if (galleries.length === 1 && galleries[0].Albums.length > 1) {
            store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
          }
          gallerie.Albums = gallerie.Albums.filter(album => album.Id !== '00000000-0000-0000-0000-000000000000')
        }
        store.commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS, galleries)
        store.commit(mutationNames.SET_SELECTED_ALBUM_TAB, newGallerieAlbum.Category)
        store.commit(mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM, null)
        // if (galleries.length === 1 && galleries[0].Albums.length <= 1) {
        // } else {
        //   store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
        // }
      }
      if (galleries.length === 1 && (galleries[0].Albums.length === 0 || galleries[0].Albums.length === 1)) {
      } else {
        store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CANCEL_IMAGE_GALLERIE_ALBUM_EDITING, (event) => {
      let gallerieData = event.dataParsed.gallerieData
      let galleries = store.getters.Galleries.map(gallerie => gallerie)
      let gallerie = galleries.find(gallerie => gallerie.Category === gallerieData.Category)
      if (gallerie && gallerie.Albums) {
        const index = gallerie.Albums.findIndex(album => album.Id === gallerieData.Id)
        gallerie.Albums.splice(index, 1, gallerieData)
      }
      store.commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS, galleries)
      store.commit(mutationNames.SET_SELECTED_ALBUM_TAB, gallerieData.Category)
      // store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_MODULE_DATA, (event) => {
      // console.log(event.dataParsed.formModule)
      let finalData = Object.assign({}, store.getters.Form, event.dataParsed.formModule)
      store.commit(mutationNames.SET_FORM, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_CHAT_MODULE_INFO, (event) => {
      let finalData = Object.assign({}, store.getters.ChatParent, event.dataParsed.chatModule)
      store.commit(mutationNames.SET_CHAT_PARENT, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.SET_PDFMODULEINFO, (event) => {
      let finalData = Object.assign({}, store.getters.Pdf, event.dataParsed.PdfModule)
      store.commit(mutationNames.SET_PDFDATA, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_PDFMODULEINFO, (event) => {
      let finalData = Object.assign({}, store.getters.Pdf, event.dataParsed.pdfModuleInfo)
      store.commit(mutationNames.UPDATE_PDFMODULEINFO, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_CHAT_CHANNEL, (event) => {
      let finalData = event.dataParsed.channel
      store.commit(mutationNames.SET_CHAT_CHANNELS, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_PDFDOCLIST, (event) => {
      let finalData = event.dataParsed.pdfDocList
      store.commit(mutationNames.UPDATE_PDFDOCLIST, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CLEAR_CHAT_CHANNEL_EDITING_DATA, (event) => {
      let newChatChannel = store.getters.NewChatChannel
      let chatsChannels = store.getters.ChatsChannels
      if (newChatChannel) {
          if (chatsChannels.length > 1) {
            store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
          }
          chatsChannels = chatsChannels.filter(channel => channel.id !== '00000000-0000-0000-0000-000000000000')
        store.commit(mutationNames.SET_CHAT_CHANNELS, chatsChannels)
        store.commit(mutationNames.CREATE_NEW_CHAT_CHANNEL, null)       
      }
      if (chatsChannels.length > 1) {
        store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CREATE_NEW_CHAT_CHANNEL, (event) => {
      let finalData = event.dataParsed.NewChatChannel
      finalData.id = '00000000-0000-0000-0000-000000000000'
      let chatsChannels = store.getters.ChatsChannels
      chatsChannels.push(finalData)      
      store.commit(mutationNames.SET_CHAT_CHANNELS, chatsChannels)
      store.commit(mutationNames.CREATE_NEW_CHAT_CHANNEL, finalData)
      if (chatsChannels.length > 1) {
        let detailViewPath = `/${finalData.detailViewName}/${store.getters.ChatParent.SubscriptionModule_Id}/00000000-0000-0000-0000-000000000000`
        store.commit(mutationNames.SET_ACTIVE_MODULE, detailViewPath)
      }
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_NEW_CHAT_CHANNEL, (event) => {
      let finalData = event.dataParsed.NewChatChannel
      let chatsChannels = store.getters.ChatsChannels
      let chatsChannel = chatsChannels.find(channel => channel.id === '00000000-0000-0000-0000-000000000000')
      Object.assign(chatsChannel, finalData)
      store.commit(mutationNames.SET_CHAT_CHANNELS, chatsChannels)
      store.commit(mutationNames.CREATE_NEW_CHAT_CHANNEL, finalData)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.CANCEL_CHAT_CHANNEL_EDITING, (event) => {
      let channelData = event.dataParsed.channelData
      let chatsChannels = store.getters.ChatsChannels
      if (chatsChannels.length > 0) {
        const index = chatsChannels.findIndex(channel => channel.id === channelData.id)
        chatsChannels.splice(index, 1, channelData)
      }
      store.commit(mutationNames.SET_CHAT_CHANNELS, chatsChannels)
      // store.commit(mutationNames.SET_ACTIVE_MODULE, `back`)
    })
    emulator.on(mutationNames.EMULATOR_NAME, mutationNames.UPDATE_CUSTOMCODE, (event) => {
      let finalData = Object.assign({}, store.getters.CustomCode, event.dataParsed.customCode)
      store.commit(mutationNames.UPDATE_CUSTOMCODE, finalData)
    })
    store.subscribe((mutation, state) => {
      if (mutation.type === mutationNames.SHOW_APPPREVIEWER_LINK) {
        emulator.emit(mutationNames.EMULATOR_NAME, mutationNames.SHOW_APPPREVIEWER_LINK, window.parent, { message: 'Message - Open AppPreviewer' }, '*')
      }
    })
  }
}

export const colorUpdationCode = (store, dataParsed) => {
  let ModulesData = Object.assign({}, store.getters.AppConfig.Modules, dataParsed.SubscriptionsModules)
  let color = HashCodeFromInt(store.getters.MainMenu.MenuItemFontColor)
  color = color.replace('#', '%23')
  ModulesData.Items = ModulesData.Items.map(item => {
    if (IsValid(item.MenuIcon)) {
      if (item.MenuIcon.substring(0, 4) === 'http') {
        let menuUri = item.MenuIcon.split('&color=')
        item.MenuIcon = `${menuUri[0]}&color=${color}`
      } else {
        let temp = item.MenuIcon.split('/')
        if (temp.length > 1) {
          let category = temp[0]
          let name = temp[1]
          let params = `category=${category}&name=${name}&outlined=${item.MenuIconOutlined}&subscriptionGuid=&color=${color}`
          item.MenuIcon = store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
        } else {
          let params = `category=&name=${item.MenuIcon}&outlined=${item.MenuIconOutlined}&subscriptionGuid=${store.getters.AppConfig.Subscription_GUID}&color=${color}`
          item.MenuIcon = store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
        }
      }
    }
    // else {
    //   let params = `category=17-navigation&name=navigation-drawer-1.svg&outlined=true&color=${color}`
    //   item.MenuIcon = store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
    // }
    return item
  })
  return ModulesData
}

export const colorMoreIconUpdationCode = (store, finalData) => {
  let color = HashCodeFromInt(finalData.MenuItemFontColor)
  color = color.replace('#', '%23')
  if (IsValid(finalData.MenuItemOverflowIcon)) {
    if (finalData.MenuItemOverflowIcon.substring(0, 4) === 'http') {
      let menuUri = finalData.MenuItemOverflowIcon.split('&color=')
      finalData.MenuItemOverflowIcon = `${menuUri[0]}&color=${color}`
    } else {
      let temp = finalData.MenuItemOverflowIcon.split('/')
      if (temp.length > 1) {
        let category = temp[0]
        let name = temp[1]
        let params = `category=${category}&name=${name}&outlined=${finalData.MenuItemOverflowIconOutlined}&subscriptionGuid=&color=${color}`
        finalData.MenuItemOverflowIcon = store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
      } else {
        let params = `category=&name=${finalData.MenuItemOverflowIcon}&outlined=${finalData.MenuItemOverflowIconOutlined}&subscriptionGuid=${store.getters.AppConfig.Subscription_GUID}&color=${color}`
        finalData.MenuItemOverflowIcon = store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
      }
    }
  }
  return finalData
}

export default createEmulatorPlugin



// WEBPACK FOOTER //
// ./src/plugins/Emulator.js